import { useEffect, useState } from 'react';
import useThemeStore from '../store/themeStore';
import ThemeBackgrounds from './ThemeBackgrounds';

const ThemeProvider = ({ children }) => {
  const { initializeTheme, activeTheme, setActiveTheme } = useThemeStore();
  const [backgroundSections, setBackgroundSections] = useState(null);

  useEffect(() => {
    // Initialize theme from localStorage
    initializeTheme();
    
    // Load backgrounds - prioritize Design Manager, fallback to Seasonal Themes
    loadBackgrounds();
  }, [initializeTheme]);

  const loadBackgrounds = async () => {
    // First check Design Manager backgrounds
    const designBgs = localStorage.getItem('background-sections');
    if (designBgs) {
      setBackgroundSections(JSON.parse(designBgs));
      return;
    }
    
    // Fallback to Seasonal Themes backgrounds
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/themes/seasonal/active`);
      if (response.ok) {
        const data = await response.json();
        if (data.backgroundSections) {
          setBackgroundSections(data.backgroundSections);
        }
      }
    } catch (error) {
      console.error('Error loading theme backgrounds:', error);
    }
  };

  useEffect(() => {
    // Apply theme colors as CSS variables
    if (activeTheme) {
      const root = document.documentElement;
      root.style.setProperty('--theme-primary', activeTheme.colors.primary);
      root.style.setProperty('--theme-secondary', activeTheme.colors.secondary);
      root.style.setProperty('--theme-tertiary', activeTheme.colors.tertiary);
      root.style.setProperty('--theme-background', activeTheme.colors.background);
      root.style.setProperty('--theme-footer-bg', activeTheme.colors.footerBg);
      root.style.setProperty('--theme-button-text', activeTheme.colors.buttonText);
    }
  }, [activeTheme]);

  return (
    <>
      {backgroundSections && <ThemeBackgrounds backgroundSections={backgroundSections} />}
      {children}
    </>
  );
};

export default ThemeProvider;
